module.exports = __webpack_public_path__ + "static/busy-building-contractor-work-2c19ac55b7282759ecb1c3229d696353.png";